export default {"src":"/_next/static/media/decorative-lines-small.cd88bf29.svg","height":39,"width":48,"blurWidth":0,"blurHeight":0};